var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllOffers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1261154650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46494 13.6414V20.8799C1.46494 26.8349 3.85225 29.2222 9.80726 29.2222H16.9559C22.9109 29.2222 25.2983 26.8349 25.2983 20.8799V13.6414",
    fill: "#DE675D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3882 15.9594C15.8153 15.9594 17.6058 13.9832 17.367 11.5561L16.4917 2.69653H10.2979L9.40932 11.5561C9.17059 13.9832 10.9611 15.9594 13.3882 15.9594Z",
    fill: "#DE675D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7571 15.9594C24.4362 15.9594 26.3991 13.7843 26.1338 11.1184L25.7624 7.47115C25.285 4.02282 23.9587 2.69653 20.4838 2.69653H16.4387L17.3671 11.9938C17.5925 14.1821 19.5687 15.9594 21.7571 15.9594Z",
    fill: "#DE675D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95306 15.9594C7.14142 15.9594 9.11759 14.1821 9.32979 11.9938L10.2582 2.69653H6.21303C2.73816 2.69653 1.41188 4.02282 0.934416 7.47115L0.57632 11.1184C0.311063 13.7843 2.27396 15.9594 4.95306 15.9594Z",
    fill: "#DE675D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3882 22.5908C11.1733 22.5908 10.0725 23.6916 10.0725 25.9065V29.2222H16.7039V25.9065C16.7039 23.6916 15.6031 22.5908 13.3882 22.5908Z",
    fill: "#DE675D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53165 11.7227V18.9612C2.53165 24.9162 4.91896 27.3035 10.874 27.3035H18.0226C23.9777 27.3035 26.365 24.9162 26.365 18.9612V11.7227",
    fill: "url(#paint0_linear_13503_843)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4549 14.0407C16.882 14.0407 18.6725 12.0645 18.4337 9.63741L17.5584 0.777832H11.3646L10.476 9.63741C10.2373 12.0645 12.0278 14.0407 14.4549 14.0407Z",
    fill: "url(#paint1_linear_13503_843)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8238 14.0407C25.5029 14.0407 27.4658 11.8656 27.2005 9.19973L26.8292 5.55245C26.3517 2.10412 25.0254 0.777832 21.5505 0.777832H17.5054L18.4338 10.0751C18.6592 12.2634 20.6354 14.0407 22.8238 14.0407Z",
    fill: "url(#paint2_linear_13503_843)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01977 14.0407C8.20814 14.0407 10.1843 12.2634 10.3965 10.0751L11.3249 0.777832H7.27974C3.80487 0.777832 2.47859 2.10412 2.00113 5.55245L1.64303 9.19973C1.37777 11.8656 3.34067 14.0407 6.01977 14.0407Z",
    fill: "url(#paint3_linear_13503_843)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4549 20.6721C12.24 20.6721 11.1392 21.7729 11.1392 23.9878V27.3035H17.7706V23.9878C17.7706 21.7729 16.6698 20.6721 14.4549 20.6721Z",
    fill: "url(#paint4_linear_13503_843)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53165 11.7227V18.9612C2.53165 24.9162 4.91896 27.3035 10.874 27.3035H18.0226C23.9777 27.3035 26.365 24.9162 26.365 18.9612V11.7227M14.4549 14.0407C16.882 14.0407 18.6725 12.0645 18.4337 9.63741L17.5584 0.777832H11.3646L10.476 9.63741C10.2373 12.0645 12.0278 14.0407 14.4549 14.0407ZM22.8238 14.0407C25.5029 14.0407 27.4658 11.8656 27.2005 9.19973L26.8292 5.55245C26.3517 2.10412 25.0254 0.777832 21.5505 0.777832H17.5054L18.4338 10.0751C18.6592 12.2634 20.6354 14.0407 22.8238 14.0407ZM6.01977 14.0407C8.20814 14.0407 10.1843 12.2634 10.3965 10.0751L11.3249 0.777832H7.27974C3.80487 0.777832 2.47859 2.10412 2.00113 5.55245L1.64303 9.19973C1.37777 11.8656 3.34067 14.0407 6.01977 14.0407ZM14.4549 20.6721C12.24 20.6721 11.1392 21.7729 11.1392 23.9878V27.3035H17.7706V23.9878C17.7706 21.7729 16.6698 20.6721 14.4549 20.6721Z",
    stroke: "url(#paint5_linear_13503_843)",
    strokeWidth: 0.729046
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 386",
    d: "M2.89266 12.2627C2.76492 12.0666 2.52756 11.7335 2.52258 11.7209L3.02901 11.6838L2.89266 12.2627Z",
    fill: "#432C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 387",
    d: "M26.2583 11.5237C26.1306 11.7198 25.455 11.9532 25.45 11.9657L25.9983 12.1965L26.3194 11.7227L26.2583 11.5237Z",
    fill: "#432C3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13503_843",
    x1: 14.4218,
    y1: 0.777831,
    x2: 14.4218,
    y2: 27.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38192D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13503_843",
    x1: 14.4218,
    y1: 0.777831,
    x2: 14.4218,
    y2: 27.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38192D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13503_843",
    x1: 14.4218,
    y1: 0.777831,
    x2: 14.4218,
    y2: 27.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38192D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13503_843",
    x1: 14.4218,
    y1: 0.777831,
    x2: 14.4218,
    y2: 27.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38192D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13503_843",
    x1: 14.4218,
    y1: 0.777831,
    x2: 14.4218,
    y2: 27.3035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38192D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13503_843",
    x1: 1.61902,
    y1: 14.3991,
    x2: 27.2245,
    y2: 14.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B51A2B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllOffers);
export default __webpack_public_path__ + "static/media/AllOffers.c64ecbdbe70ca9d3aef5f8d87393a63c.svg";
export { ForwardRef as ReactComponent };